import React from 'react';
import { Table, Heading } from '@zillow/constellation';
import { IOldTransactionResponse } from '../../../../../types/order/escrow/response/IOldTransactionResponse';
import { OldTransactionRow } from './OldTransactionRow';

interface IOldTransactionsTableProps {
  oldTransactions: IOldTransactionResponse[];
}

const tableHeaders = [
  'Type',
  'Method',
  'Description',
  'Amount',
  'Category',
  'Memo',
  'Period',
  'Issued',
  'Cleared',
  'Account',
  'Account #',
];

export const OldTransactionsTable: React.FC<IOldTransactionsTableProps> = ({ oldTransactions }) => {
  return (
    <>
      <Heading level={1}>Old Transactions</Heading>
      <Table aria-label="Old Transactions" size={'sm'} appearance={'zebra'}>
        <Table.Header appearance={'dark'}>
          <Table.Row>
            {tableHeaders.map((header) => (
              <Table.HeaderCell key={header}>{header}</Table.HeaderCell>
            ))}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {oldTransactions.map((item, index) => (
            <OldTransactionRow key={`${item.description}-${index}`} item={item} />
          ))}
        </Table.Body>
      </Table>
    </>
  );
};
